import { MyProfileCardHeaderWidgetInstance } from "../MyProfileCardHeaderWidgetClass"
import { useMyProfileCardHeaderWidget } from "../model/useMyProfileCardHeaderWidget"
import { MyProfileCardHeaderWidgetView } from "./MyProfileCardHeaderWidgetView"

export interface MyProfileCardHeaderWidgetProps {
  widget: MyProfileCardHeaderWidgetInstance
}

export function MyProfileCardHeaderWidgetConnector(
  props: MyProfileCardHeaderWidgetProps
) {
  return (
    <MyProfileCardHeaderWidgetView {...useMyProfileCardHeaderWidget(props)} />
  )
}
